import { AboveTheFoldCTA } from "./AboveTheFoldCTA";
import type { AboveTheFoldCTAProps } from "./AboveTheFoldCTA.d";

export { AboveTheFoldCTA };
export type { AboveTheFoldCTAProps };
